import { ApiPromise, WsProvider } from '@polkadot/api'

export function connectToNode (websocket) {
  const wsProvider = new WsProvider(websocket)
  const api = new ApiPromise({ provider: wsProvider })

  return api
}
